import React from 'react'

import cn from 'classnames'
import s from './CtaTopRight.scss'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

export default props => {
  const { text, children } = props
  return (
    <div
      className={cn(
        s.cta,
        sLay['layout-row'],
        sLay['layout-align-xs-center-center'],
        sLay['layout-align-gt-xs-end-center']
      )}
    >
      <div className={sText.descrip2} style={{ marginRight: '15px' }}>
        {text}
      </div>
      {children}
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/CtaTopRight/CtaTopRight.jsx